import mapActions from './mapActions';

export default mapActions('order_work_detail', {
    fetchAll_url: (data) => {
        return `/api/orders/${data.order_id}/employee/${data.employee_id}`;}
});